import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation('common');
  return (
    <main role="main" className="not-found">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
    </main>
  );
}
